import {timestampToTimeFormat, timeStringToTimestamp} from "../components/ComUtils/TimeFormat";

const offsetsMixin = {

  data() {
    return {
      //菜单的id，用来从dom中删除菜单
      contextMenuId: null,
      selectListMenuId: null,
      createDataSetMenuId: null,
      dataBaseListMenuId: null,
      //记录菜单的位置
      menuTop: null,
      menuLeft: null,
      //补偿数据
      dataList: [],
      nowData: {
        name: null,
        default: null,
        type: null,
        childType: null,
        range: null,
        num: null,
        phaseNum: null,
        timestamp: null
      },
      //分页
      nowPage: 0,
      totalPages: 0,
      pageSize: 10,
      //记录测点的幅值通频等所有数据，用于补偿计算
      chartData: null,
      //特征值
      nowFeature: '',
      //放图谱初始数据，用于还原
      originalDataMap: null,
      //记录需要补偿的数据series
      nowSeriesIndex: 0,
      //请求
      requistData: null,
      //映射
      typeMap: {
        '启动': 0,
        '停机': 1,
        '其他': 2
      },
      reverseTypeMap: {
        0: '启动',
        1: '停机',
        2: '其他'
      },
      childTypeMap: {
        '热': 0,
        '冷': 1,
        '其他': 2
      },
      reverseChildTypeMap: {
        0: '热',
        1: '冷',
        2: '其他'
      },
      rangeMap: {
        '趋势图': 1,
        '波形图': 2,
        '伯德图': 128,
        '极坐标图': 256,
        '轴心位置': 512,
        '轴心轨迹': 1024,
      },
      mask: null
    }
  },

  methods: {
    //右键菜单
    contextMenu(event) {
      this.clear()
      const menu = document.createElement('div');
      this.contextMenuId = new Date().toISOString();
      menu.id = this.contextMenuId
      menu.style.position = 'fixed';
      menu.style.top = `${event.event.clientY}px`;
      menu.style.left = `${event.event.clientX}px`;
      this.menuTop = event.event.clientY;
      this.menuLeft = event.event.clientX;
      Object.assign(menu.style, {
        display: 'block',
        padding: '6px 12px',
        fontSize: '10px',
        lineHeight: '14px',
        zIndex: 999999999,
        backgroundColor: this.$store.state.conbgcolor,
        color: this.$store.state.textcolor,
        textDecoration: 'none',
        cursor: 'pointer',
        userSelect: 'none',
        borderRadius: '4px',
        border: '1px solid #ccc'
      });

      const offsets = document.createElement('a');
      offsets.href = 'javascript:void(0)';
      offsets.textContent = this.translateText('textMap.', '补偿');
      Object.assign(offsets.style, {
        display: 'block',            // 块级元素，占满容器宽度
        fontSize: '14px',            // 字号
        color: this.$store.state.textcolor,               // 字体颜色
        textDecoration: 'none',      // 去掉默认下划线
        cursor: 'pointer',           // 鼠标变手型
        userSelect: 'none',          // 禁止选中文本
        transition: 'background-color 0.2s ease' // 背景色渐变效果
      });
      offsets.addEventListener('click', this.trendOffsets);
      //这里添加下拉菜单的内容
      menu.appendChild(offsets);

      //插入到图谱中
      const chartDom = document.getElementById('myTrendChart');
      chartDom.appendChild(menu)

      //单击其它位置销毁
      const onClickOutside = (e) => {
        if (!menu.contains(e.target)) {
          menu.remove();
          chartDom.removeEventListener('click', onClickOutside);
        }
      }
      chartDom.addEventListener('click', onClickOutside);
    },

    //补偿功能总菜单
    trendOffsets() {
      this.clear()

      const selectListMenu = document.createElement('div');
      selectListMenu.id = new Date().toISOString();
      this.selectListMenuId = selectListMenu.id;
      selectListMenu.style.position = 'fixed';
      selectListMenu.style.top = this.menuTop.toString() + 'px';
      selectListMenu.style.left = this.menuLeft.toString() + 'px';
      selectListMenu.className = 'selectListMenu';

      const selectListMenuHeader = document.createElement('div');
      selectListMenuHeader.className = 'selectListMenuHeader';
      selectListMenuHeader.textContent = this.translateText('textMap.', '补偿');

      const wrapper = document.createElement('div');
      wrapper.classList.add('deleteMenuWrapper');
      const deleteMenu = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      deleteMenu.setAttribute('viewBox', '0 0 1024 1024');
      deleteMenu.setAttribute('class', 'deleteMenuIcon');
      const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', 'M921.6 849.92L634.88 563.2 921.6 276.48 849.92 204.8 563.2 491.52 276.48 204.8l-71.68 71.68 286.72 286.72L204.8 849.92l71.68 71.68 286.72-286.72L849.92 921.6z');
      deleteMenu.appendChild(path);
      wrapper.appendChild(deleteMenu);
      wrapper.addEventListener('click', () => {
        selectListMenu.remove();
      });
      selectListMenuHeader.appendChild(wrapper);

      let isDragging, offsetX, offsetY;
      selectListMenuHeader.addEventListener('mousedown', function (e) {
        // 只允许鼠标左键拖动
        if (e.button !== 0) return;

        isDragging = true;
        offsetX = e.clientX - selectListMenu.offsetLeft;
        offsetY = e.clientY - selectListMenu.offsetTop;

        // 改变光标
        selectListMenu.style.cursor = 'move';

        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
      });

      function onMouseMove(e) {
        if (!isDragging) return;
        selectListMenu.style.left = `${e.clientX - offsetX}px`;
        selectListMenu.style.top = `${e.clientY - offsetY}px`;
      }

      function onMouseUp() {
        isDragging = false;
        selectListMenu.style.cursor = 'default';

        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
      }

      selectListMenu.appendChild(selectListMenuHeader);

      const selectListMenuBody = document.createElement('div');
      selectListMenuBody.className = 'selectListMenuBody';

      const optionOne = document.createElement('option');
      optionOne.className = 'option';
      optionOne.style.cursor = 'pointer';
      optionOne.textContent = this.translateText('textMap.', '无');
      optionOne.addEventListener('click', this.restore)
      selectListMenuBody.appendChild(optionOne);

      const optionTwo = document.createElement('option');
      optionTwo.className = 'option';
      optionTwo.style.cursor = 'pointer';
      optionTwo.textContent = this.translateText('textMap.', '默认');
      optionTwo.addEventListener('click', async () => {
        if (!this.PrimaryLine) {
          this.$message({
            message: this.translateText("textMap.", '未选中补偿数据集'),
            type: 'warning'
          });
          return
        }

        this.nowSeriesIndex = this.PrimaryLineSeriesNameIndex ? this.PrimaryLineSeriesNameIndex : 0;

        let url = `/mark/getDefault?equipmentUuid=${this.requistData.equipmentUuid}&pointUuid=${this.requistData.pointTree[this.nowSeriesIndex].pointUuid}&feature=${this.requistData.feature}`
        try {
          let res = await this.$axios.get(url);
          if(res.data.code == 200) {
            let url = '';
            if(res.data.data.info.eventId){
              url = "/wave-spectrum/" + this.requistData.equipmentUuid + '/' + encodeURIComponent(encodeURIComponent(this.requistData.pointIdString.split(',')[this.nowSeriesIndex])) + '/' + res.data.data.markTime + '/16384/0/info?eventId=' + res.data.data.info.eventId + '&rev=' + res.data.data.info.rev
            }else{
              url = "/wave-spectrum/" + this.requistData.equipmentUuid + '/' + encodeURIComponent(encodeURIComponent(this.requistData.pointIdString.split(',')[this.nowSeriesIndex])) + '/' + res.data.data.markTime + '/16384/0/info'
            }
            let res1 = await this.$axios.get(url);
            this.nowData.timestamp = res.data.data.markTime;
            if (this.nowFeature == 'one' || this.nowFeature == 'phaseOne') {
              this.nowData.phaseNum = res1.data.data.trendValue[0].phaseOne;
              this.nowData.num = res1.data.data.trendValue[0].one;
            } else if (this.nowFeature == 'two' || this.nowFeature == 'phaseTwo') {
              this.nowData.phaseNum = res1.data.data.trendValue[0].phaseTwo;
              this.nowData.num = res1.data.data.trendValue[0].two;
            } else if (this.nowFeature == 'three' || this.nowFeature == 'phaseThree') {
              this.nowData.phaseNum = res1.data.data.trendValue[0].phaseThree;
              this.nowData.num = res1.data.data.trendValue[0].three;
            } else if (this.nowFeature == 'half' || this.nowFeature == 'phaseHalf') {
              this.nowData.phaseNum = res1.data.data.trendValue[0].phaseHalf;
              this.nowData.num = res1.data.data.trendValue[0].half;
            }
          }else{
            this.$message({
              message: this.translateText("textMap.", '获取失败'),
              type: 'warning'
            });
            return;
          }
        }catch (e){
          this.$message({
            message: this.translateText("textMap.", '获取失败'),
            type: 'warning'
          });
          return;
        }
        this.offsets();
      })
      selectListMenuBody.appendChild(optionTwo);

      const optionThree = document.createElement('option');
      optionThree.className = 'option';
      optionThree.style.cursor = 'pointer';
      optionThree.textContent = this.translateText('textMap.', '从数据库选择');
      optionThree.addEventListener('click', () => {
        if (!this.PrimaryLine) {
          this.$message({
            message: this.translateText("textMap.", '未选中补偿数据集'),
            type: 'warning'
          });
          return
        }

        this.nowSeriesIndex = this.PrimaryLineSeriesNameIndex ? this.PrimaryLineSeriesNameIndex : 0;
        this.dataBaseListMenu();
      })
      selectListMenuBody.appendChild(optionThree);

      const optionFour = document.createElement('option');
      optionFour.className = 'option';
      optionFour.style.cursor = 'pointer';
      optionFour.textContent = this.translateText('textMap.', '第一个基准数据');
      optionFour.addEventListener('click', () => {
        for (this.nowSeriesIndex = 0; this.nowSeriesIndex < this.chartData.trendInfo[0].trendValue.length; this.nowSeriesIndex++) {
          let slow = this.chartData.trendInfo[0].trendValue[this.nowSeriesIndex];
          this.nowData.timestamp = this.chartData.trendInfo[0].trendTime
          if (this.nowFeature == 'one' || this.nowFeature == 'phaseOne') {
            this.nowData.phaseNum = slow.phaseOne;
            this.nowData.num = slow.one;
          } else if (this.nowFeature == 'two' || this.nowFeature == 'phaseTwo') {
            this.nowData.phaseNum = slow.phaseTwo;
            this.nowData.num = slow.two;
          } else if (this.nowFeature == 'three' || this.nowFeature == 'phaseThree') {
            this.nowData.phaseNum = slow.phaseThree;
            this.nowData.num = slow.three;
          } else if (this.nowFeature == 'half' || this.nowFeature == 'phaseHalf') {
            this.nowData.phaseNum = slow.phaseHalf;
            this.nowData.num = slow.half;
          }
          this.offsets();
        }
        // this.nowSeriesIndex = 0;
      })
      selectListMenuBody.appendChild(optionFour);

      const optionFive = document.createElement('option');
      optionFive.className = 'option';
      optionFive.style.cursor = 'pointer';
      optionFive.textContent = this.translateText('textMap.', '最后一个基准数据');
      optionFive.addEventListener('click', () => {
        for (this.nowSeriesIndex = 0; this.nowSeriesIndex < this.chartData.trendInfo[0].trendValue.length; this.nowSeriesIndex++) {
          this.nowData.timestamp = this.chartData.trendInfo[this.chartData.trendInfo.length - 1].trendTime
          let slow = this.chartData.trendInfo[this.chartData.trendInfo.length - 1].trendValue[this.nowSeriesIndex];
          if (this.nowFeature == 'one' || this.nowFeature == 'phaseOne') {
            this.nowData.phaseNum = slow.phaseOne;
            this.nowData.num = slow.one;
          } else if (this.nowFeature == 'two' || this.nowFeature == 'phaseTwo') {
            this.nowData.phaseNum = slow.phaseTwo;
            this.nowData.num = slow.two;
          } else if (this.nowFeature == 'three' || this.nowFeature == 'phaseThree') {
            this.nowData.phaseNum = slow.phaseThree;
            this.nowData.num = slow.three;
          } else if (this.nowFeature == 'half' || this.nowFeature == 'phaseHalf') {
            this.nowData.phaseNum = slow.phaseHalf;
            this.nowData.num = slow.half;
          }
          this.offsets();
        }
        // this.nowSeriesIndex = 0;
      })
      selectListMenuBody.appendChild(optionFive);

      const optionSix = document.createElement('option');
      optionSix.className = 'option';
      optionSix.style.cursor = 'pointer';
      optionSix.textContent = this.translateText('textMap.', '当前基准数据');
      optionSix.addEventListener('click', () => {
        if (!this.PrimaryLine) {
          this.$message({
            message: this.translateText("textMap.", '未选中补偿点'),
            type: 'warning'
          });
          return
        }
        let trendTime = timeStringToTimestamp(this.PrimaryLine);
        console.log(this.PrimaryLineSeriesNameIndex)
        this.nowSeriesIndex = this.PrimaryLineSeriesNameIndex ? this.PrimaryLineSeriesNameIndex : 0;
        this.nowData.timestamp = this.chartData.trendInfo[this.PrimaryLineParam.xIndex].trendTime
        let slow = this.chartData.trendInfo.find(item => item.trendTime === trendTime).trendValue[this.nowSeriesIndex];
        if (this.nowFeature == 'one' || this.nowFeature == 'phaseOne') {
          this.nowData.phaseNum = slow.phaseOne;
          this.nowData.num = slow.one;
        } else if (this.nowFeature == 'two' || this.nowFeature == 'phaseTwo') {
          this.nowData.phaseNum = slow.phaseTwo;
          this.nowData.num = slow.two;
        } else if (this.nowFeature == 'three' || this.nowFeature == 'phaseThree') {
          this.nowData.phaseNum = slow.phaseThree;
          this.nowData.num = slow.three;
        } else if (this.nowFeature == 'half' || this.nowFeature == 'phaseHalf') {
          this.nowData.phaseNum = slow.phaseHalf;
          this.nowData.num = slow.half;
        }
        this.offsets();
      })
      selectListMenuBody.appendChild(optionSix);

      selectListMenu.appendChild(selectListMenuBody);

      const selectListMenuBottom = document.createElement('div');
      selectListMenuBottom.className = 'selectListMenuBottom';
      const optionBottom = document.createElement('option');
      optionBottom.className = 'option';
      optionBottom.style.cursor = 'pointer';
      optionBottom.textContent = this.translateText('textMap.', '创建新数据集');
      optionBottom.addEventListener('click', () => {
        if(!this.PrimaryLine){
          this.$message({
            message: this.translateText("textMap.", '未选中补偿数据集'),
            type: 'warning'
          });
          return
        }
        this.nowSeriesIndex = this.PrimaryLineSeriesNameIndex ? this.PrimaryLineSeriesNameIndex : 0;
        this.createDataSetMenu()
      })
      selectListMenuBottom.appendChild(optionBottom);
      selectListMenu.appendChild(selectListMenuBottom);


      const chartDom = document.getElementById('myTrendChart');
      chartDom.appendChild(selectListMenu);

    },

    //创建数据集菜单
    createDataSetMenu() {

      this.clear()

      const createDataSetMenu = document.createElement('div');
      createDataSetMenu.id = new Date().toISOString();
      this.createDataSetMenuId = createDataSetMenu.id;
      createDataSetMenu.style.position = 'fixed';
      createDataSetMenu.style.top = '20%';
      createDataSetMenu.style.left = '50%';
      createDataSetMenu.style.transform = 'translateX(-50%)';
      createDataSetMenu.className = 'createDataSetMenu';

      const createDataSetMenuHeader = document.createElement('div');
      createDataSetMenuHeader.className = 'createDataSetMenuHeader';
      let detail = this.$store.state.equipmentDetail[this.$store.state.equid][0];
      createDataSetMenuHeader.textContent = detail.groupName + '>' + detail.companyName + '>' + detail.factoryName + '>' + detail.unitName + '>' + detail.equipmentName

      const wrapper = document.createElement('div');
      wrapper.classList.add('deleteMenuWrapper');
      const deleteMenu = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      deleteMenu.setAttribute('viewBox', '0 0 1024 1024');
      deleteMenu.setAttribute('class', 'deleteMenuIcon');
      const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', 'M921.6 849.92L634.88 563.2 921.6 276.48 849.92 204.8 563.2 491.52 276.48 204.8l-71.68 71.68 286.72 286.72L204.8 849.92l71.68 71.68 286.72-286.72L849.92 921.6z');
      deleteMenu.appendChild(path);
      wrapper.appendChild(deleteMenu);
      wrapper.addEventListener('click', () => {
        this.clear()
      });
      createDataSetMenuHeader.appendChild(wrapper)

      let isDragging, offsetX, offsetY;
      createDataSetMenuHeader.addEventListener('mousedown', function (e) {
        // 只允许鼠标左键拖动
        if (e.button !== 0) return;

        isDragging = true;
        offsetX = e.clientX - createDataSetMenu.offsetLeft;
        offsetY = e.clientY - createDataSetMenu.offsetTop;

        // 改变光标
        createDataSetMenu.style.cursor = 'move';

        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
      });

      function onMouseMove(e) {
        if (!isDragging) return;
        createDataSetMenu.style.left = `${e.clientX - offsetX}px`;
        createDataSetMenu.style.top = `${e.clientY - offsetY}px`;
      }

      function onMouseUp() {
        isDragging = false;
        createDataSetMenu.style.cursor = 'default';

        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
      }

      createDataSetMenu.appendChild(createDataSetMenuHeader);


      const createDataSetMenuBody = document.createElement('div');
      createDataSetMenuBody.className = 'createDataSetMenuBody';
      createDataSetMenuBody.innerHTML = `
        <div class="formItem">
            <span class="title">${this.translateText("textMap.", '基准数据名称') + "："}</span> <input class="name" type="text" id="name" maxlength="50" value="${this.requistData.pointTree[this.nowSeriesIndex].label + ' ' + timestampToTimeFormat(this.chartData.trendInfo[this.PrimaryLineParam.xIndex].trendTime)}">
        </div>
        <div class="formItem">
          <span class="title">${this.translateText("textMap.", '默认') + "："}</span> <input class="default" type="checkbox">
        </div>
        <div class="formItem">
          <span class="title">${this.translateText("textMap.", '类型') + "："}</span>
          <input class="type" type="radio" name="type" checked value="启动"><span class="optionConf">${this.translateText("textMap.", '启动')}</span>
          <input class="type" type="radio" name="type" value="停机"><span class="optionConf">${this.translateText("textMap.", '停机')}</span>
          <input class="type" type="radio" name="type" value="其他"><span class="optionConf">${this.translateText("textMap.", '其他')}</span>
        </div>
        <div class="formItem" id="formItem4">
          <span class="title">${this.translateText("textMap.", '子类型') + "："}</span>
          <input class="childType" type="radio" name="childType" checked value="热"><span class="optionConf">${this.translateText("textMap.", '热')}</span>
          <input class="childType" type="radio" name="childType" value="冷"><span class="optionConf">${this.translateText("textMap.", '冷')}</span>
          <input class="childType" type="radio" name="childType" value="其他"><span class="optionConf">${this.translateText("textMap.", '其他')}</span>
        </div>
        <div class="formItem" id="formItem5" style="display: none;">
          <span class="title">${this.translateText("textMap.", '补偿范围') + ":"}</span>
          <input class="range" type="checkbox" name="range" checked value="趋势图"><span class="optionConf">${this.translateText("textMap.", '趋势图')}</span>
          <input class="range" type="checkbox" name="range" checked value="波形图"><span class="optionConf">${this.translateText("textMap.", '波形图')}</span>
          <input class="range" type="checkbox" name="range" checked value="伯德图"><span class="optionConf">${this.translateText("textMap.", '伯德图')}</span>
          <input class="range" type="checkbox" name="range" checked value="极坐标图"><span class="optionConf">${this.translateText("textMap.", '极坐标图')}</span>
          <input class="range" type="checkbox" name="range" checked value="轴心位置"><span class="optionConf">${this.translateText("textMap.", '轴心位置')}</span>
          <input class="range" type="checkbox" name="range" checked value="轴心轨迹"><span class="optionConf">${this.translateText("textMap.", '轴心轨迹')}</span>
        </div>
        <div class="formItem">
            <span class="title">${this.translateText("textMap.", '备注') + "："}</span> <input class="name" type="text" id="remark" maxlength="100" value="">
        </div>
        <div class="buttons">
          <button id="createDataSetCancel"">${this.translateText("textMap.", '取消')}</button>
          <button id="createDataSetSave">${this.translateText("textMap.", '保存')}</button>
        </div>
      `;


      createDataSetMenu.appendChild(createDataSetMenuBody);

      const chartDom = document.getElementById('myTrendChart');
      chartDom.appendChild(createDataSetMenu);

      this.mask = document.createElement('div');
      this.mask.className = 'createDataSetMask';
      this.mask.id = 'createDataSetMask';
      this.mask.addEventListener('click', () => {
        this.clear();
      });
      document.body.appendChild(this.mask);

      const titles = createDataSetMenuBody.querySelectorAll('.title');
      let maxWidth = 0;

      titles.forEach(title => {
        const width = title.getBoundingClientRect().width;
        if (width > maxWidth) maxWidth = width;
      });

      titles.forEach(title => {
        title.style.width = maxWidth + 'px';
        title.style.display = 'inline-block'; // 保证 width 生效
      });

      const currentWidth = createDataSetMenu.scrollWidth;
      createDataSetMenu.style.width = currentWidth + 20 + 'px';

      const createDataSetCancel = document.getElementById('createDataSetCancel');
      createDataSetCancel.addEventListener('click', () => {
        this.clear()
      });
      const createDataSetSave = document.getElementById('createDataSetSave');
      createDataSetSave.addEventListener('click', () => {
        if(this.PrimaryLineSeriesNameIndex == undefined || this.PrimaryLineSeriesNameIndex == null){
          this.$message({
            message: this.translateText("textMap.", '未选中补偿数据集'),
            type: 'warning'
          });
          return
        }else{
          this.nowSeriesIndex = this.PrimaryLineSeriesNameIndex ? this.PrimaryLineSeriesNameIndex : 0;
        }

        if(!document.querySelector('.name').value){
          this.$message({
            message: this.translateText("textMap.", '请输入基准数据名称'),
            type: 'warning'
          });
          return
        }
        if(!document.querySelector('input[name="type"]:checked')){
          this.$message({
            message: this.translateText("textMap.", '请选择类型'),
            type: 'warning'
          });
          return
        }
        if(!document.querySelector('input[name="childType"]:checked')){
          this.$message({
            message: this.translateText("textMap.", '请选择子类型'),
            type: 'warning'
          });
          return
        }
        if(!Array.from(document.querySelectorAll('input[name="range"]:checked')).map(item => item.value).length){
          this.$message({
            message: this.translateText("textMap.", '至少选择一个补偿范围'),
            type: 'warning'
          });
          return
        }


        const data = {
          name: document.querySelector('#name').value,
          isDefault: document.querySelector('.default').checked,
          type: document.querySelector('input[name="type"]:checked').value,
          childType: document.querySelector('input[name="childType"]:checked').value,
          range: Array.from(document.querySelectorAll('input[name="range"]:checked')).map(item => item.value),
          remark: document.querySelector('#remark').value
        }
        this.createDataSet(data)
      })
    },

    //添加补偿数据
    async createDataSet(value) {
      let url = '/mark/add';
      let phase;
      let amplitude;
      if (this.nowFeature == 'one' || this.nowFeature == 'phaseOne') {
        phase = 'phaseOne';
        amplitude = 'one';
      } else if (this.nowFeature == 'two' || this.nowFeature == 'phaseTwo') {
        phase = 'phaseTwo';
        amplitude = 'two';
      } else if (this.nowFeature == 'three' || this.nowFeature == 'phaseThree') {
        phase = 'phaseThree';
        amplitude = 'three';
      } else if (this.nowFeature == 'half' || this.nowFeature == 'phaseHalf') {
        phase = 'phaseHalf';
        amplitude = 'half';
      }
      let offsetsRange = 0;
        value.range.forEach(item => {
        offsetsRange += this.rangeMap[item]
      })
      let rev = this.chartData.trendInfo[this.PrimaryLineParam.xIndex].trendValue[this.nowSeriesIndex]['rev'];
        let sampleFreq = this.chartData.trendInfo[this.PrimaryLineParam.xIndex].trendValue[this.nowSeriesIndex]['sampleFreq'];
      const postData = {
        equipmentUuid: this.requistData.equipmentUuid,
        pointUuid: this.requistData.pointTree[this.nowSeriesIndex].pointUuid,
        markTime: this.chartData.trendInfo[this.PrimaryLineParam.xIndex].trendTime,
        feature: this.requistData.feature,
        eventType: 1,
        amplitude: this.chartData.trendInfo[this.PrimaryLineParam.xIndex].trendValue[this.nowSeriesIndex][amplitude],
        phase: this.chartData.trendInfo[this.PrimaryLineParam.xIndex].trendValue[this.nowSeriesIndex][phase],
        name: value.name,
        isDefault: value.isDefault ? 1 : 0,
        datatype: this.typeMap[value.type],
        childType: this.childTypeMap[value.childType],
        offsetsRange: offsetsRange,
        remark: value.remark,
        info: {
          pointIdString: this.requistData.pointIdString.split(',')[this.nowSeriesIndex],
          rev: rev,
          intervalNum: rev > 0 ? Math.ceil(1 / (rev / 60) * sampleFreq) : 0,
          waveNumber: 16384,
          analysisLines: 0
        }
      }
      console.log('postData', postData);
      await this.$axios.post(url, postData).then(res => {
        if(res.data.code == 200){
          this.$message({
            message: this.translateText("textMap.", '创建成功'),
            type: 'success'
          });
          this.clear();
        }else{
          this.$message({
            message: this.translateText("textMap.", '创建失败'),
            type: 'warning'
          });
        }
      }).catch(e => {
        this.$message({
          message: this.translateText("textMap.", '创建失败'),
          type: 'warning'
        });
      })

      // this.clear();
    },

    //补偿数据集list菜单
    async dataBaseListMenu() {

      this.clear()

      const dataBaseListMenu = document.createElement('div');
      dataBaseListMenu.id = new Date().toISOString();
      this.dataBaseListMenuId = dataBaseListMenu.id;
      dataBaseListMenu.style.position = 'fixed';
      dataBaseListMenu.style.top = '20%';
      dataBaseListMenu.style.left = '50%';
      dataBaseListMenu.style.transform = 'translateX(-50%)';
      dataBaseListMenu.className = 'dataBaseListMenu';

      const dataBaseListMenuHeader = document.createElement('div');
      dataBaseListMenuHeader.className = 'dataBaseListMenuHeader';
      let detail = this.$store.state.equipmentDetail[this.$store.state.equid][0];
      dataBaseListMenuHeader.textContent = detail.groupName + '>' + detail.companyName + '>' + detail.factoryName + '>' + detail.unitName + '>' + detail.equipmentName

      const wrapper = document.createElement('div');
      wrapper.classList.add('deleteMenuWrapper');
      const deleteMenu = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      deleteMenu.setAttribute('viewBox', '0 0 1024 1024');
      deleteMenu.setAttribute('class', 'deleteMenuIcon');
      const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', 'M921.6 849.92L634.88 563.2 921.6 276.48 849.92 204.8 563.2 491.52 276.48 204.8l-71.68 71.68 286.72 286.72L204.8 849.92l71.68 71.68 286.72-286.72L849.92 921.6z');
      deleteMenu.appendChild(path);
      wrapper.appendChild(deleteMenu);
      wrapper.addEventListener('click', () => {
        this.clear();
      });
      dataBaseListMenuHeader.appendChild(wrapper)

      let isDragging, offsetX, offsetY;
      dataBaseListMenuHeader.addEventListener('mousedown', function (e) {
        // 只允许鼠标左键拖动
        if (e.button !== 0) return;

        isDragging = true;
        offsetX = e.clientX - dataBaseListMenu.offsetLeft;
        offsetY = e.clientY - dataBaseListMenu.offsetTop;

        // 改变光标
        dataBaseListMenu.style.cursor = 'move';

        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
      });

      function onMouseMove(e) {
        if (!isDragging) return;
        dataBaseListMenu.style.left = `${e.clientX - offsetX}px`;
        dataBaseListMenu.style.top = `${e.clientY - offsetY}px`;
      }

      function onMouseUp() {
        isDragging = false;
        dataBaseListMenu.style.cursor = 'default';

        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
      }

      dataBaseListMenu.appendChild(dataBaseListMenuHeader);

      const dataBaseListMenuBody = document.createElement('div');
      dataBaseListMenuBody.className = 'dataBaseListMenuBody';

      const dataList = document.createElement('div');
      dataList.className = 'dataList';
      dataBaseListMenuBody.appendChild(dataList);

      //分页功能开始
      const drawListAndPagination = async () => {

        const table = document.createElement('table');
        const thead = document.createElement('thead');
        thead.innerHTML = `
          <tr>
            <th style="width: 46px"></th>
            <th style="width: 46px">${this.translateText("textMap.", '序号')}</th>
            <th style="width: 201px">${this.translateText("textMap.", '基准数据名称')}</th>
            <th style="width: 186px">${this.translateText("textMap.", '类型')}</th>
            <th style="width: 193px">${this.translateText("textMap.", '子类型')}</th>
            <th style="width: 210px">${this.translateText("textMap.", '采集时间')}</th>
            <th style="width: 210px">${this.translateText("textMap.", '备注')}</th>
            <th style="width: 112px">${this.translateText("textMap.", '操作')}</th>
          </tr>
        `;
        table.appendChild(thead);

        // 请求接口
        const url = `/mark/list?equipmentUuid=${this.requistData.equipmentUuid}&pointUuid=${this.requistData.pointTree[this.nowSeriesIndex].pointUuid}&feature=${this.requistData.feature}&offsetRange=1&page=${this.nowPage}&size=${this.pageSize}&eventType=1`;
        try {
          const res = await this.$axios.get(url);
          if (res.data.code === 200) {
            this.dataList = res.data.data.content;
            this.totalPages = res.data.data.totalPages;
          }
        } catch (e) {
          // this.$message({
          //   message: this.translateText("textMap.", '删除成功'),
          //   type: 'warning'
          // });
          console.error('分页请求失败:', e);
        }

        const tbody = document.createElement('tbody');
        this.dataList.forEach((item, index) => {
          const tr = document.createElement('tr');

          tr.innerHTML = `
            <td><input type="radio" name="nowDataInDataBaseListMenu" value="${index}"></td>
            <td>${index + 1 + this.nowPage * this.pageSize}</td>
            <td>${item.name}</td>
            <td>${this.translateText("textMap.", this.reverseTypeMap[item.datatype])}</td>
            <td>${this.translateText("textMap.", this.reverseChildTypeMap[item.childType])}</td>
            <td>${timestampToTimeFormat(item.markTime)}</td>
            <td>${item.remark}</td>
            <td class="actions"></td>
          `;

          // 创建“删除”按钮
          const deleteBtn = document.createElement('button');
          deleteBtn.className = 'deleteBtn';
          deleteBtn.innerHTML = `
  <svg t="1751429082920" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3008" width="16" height="16" display="block"><path d="M519.620465 0c-103.924093 0-188.511256 82.467721-192.083349 185.820279H85.015814A48.91386 48.91386 0 0 0 36.101953 234.686512a48.91386 48.91386 0 0 0 48.913861 48.866232h54.010046V831.345116c0 102.852465 69.822512 186.844279 155.909954 186.844279h439.200744c86.087442 0 155.909953-83.491721 155.909954-186.844279V284.100465h48.91386a48.91386 48.91386 0 0 0 48.913861-48.890046 48.91386 48.91386 0 0 0-48.913861-48.866233h-227.756651A191.559442 191.559442 0 0 0 519.620465 0z m-107.234232 177.080558c3.548279-49.771163 46.627721-88.540279 99.851907-88.540279 53.224186 0 96.327442 38.745302 99.351813 88.540279h-199.20372z m-111.997024 752.044651c-30.981953 0-65.083535-39.15014-65.083535-95.041488V287.744h575.488v546.839814c0 55.915163-34.077767 95.041488-65.059721 95.041488H300.389209v-0.500093z" fill="#d81e06" p-id="3009"></path><path d="M368.116093 796.814884c24.361674 0 44.27014-21.670698 44.27014-48.818605v-278.623256c0-27.147907-19.908465-48.818605-44.27014-48.818604-24.33786 0-44.27014 21.670698-44.27014 48.818604v278.623256c0 27.147907 19.360744 48.818605 44.293954 48.818605z m154.933581 0c24.361674 0 44.293953-21.670698 44.293954-48.818605v-278.623256c0-27.147907-19.932279-48.818605-44.293954-48.818604-24.33786 0-44.27014 21.670698-44.270139 48.818604v278.623256c0 27.147907 19.932279 48.818605 44.293953 48.818605z m132.810419 0c24.33786 0 44.27014-21.670698 44.27014-48.818605v-278.623256c0-27.147907-19.932279-48.818605-44.27014-48.818604s-44.27014 21.670698-44.27014 48.818604v278.623256c0 27.147907 19.360744 48.818605 44.27014 48.818605z" fill="#d81e06" p-id="3010"></path></svg>
`;
          deleteBtn.onclick = async () => {
            try {
              const res = await this.$axios.delete(`/mark/delete/${item.id}`);
              if (res.data.code === 200) {
                this.$message({
                  message: this.translateText("textMap.", '删除成功'),
                  type: 'success'
                });
                if(this.dataList.length == 1 && this.nowPage > 0) this.nowPage -= 1;
                drawListAndPagination(); // 刷新当前页
              } else {
                this.$message({
                  message: this.translateText("textMap.", '删除失败'),
                  type: 'warning'
                });
              }
            } catch (e) {
              this.$message({
                message: this.translateText("textMap.", '删除失败'),
                type: 'warning'
              });
            }
          };

          // 创建“默认”按钮
          const defaultBtn = document.createElement('button');
          defaultBtn.innerText = this.translateText("textMap.", '默认');
          defaultBtn.className = 'defaultBtn';
          defaultBtn.disabled = item.isDefault === 1;
          defaultBtn.onclick = async () => {
            // 可在此添加“设为默认”的接口调用逻辑
            let url = `/mark/setDefault?id=${item.id}`;
            this.$axios.post(url).then(res => {
              if (res.data.code === 200) {
                this.$message({
                  message: this.translateText("textMap.", '设置成功'),
                  type: 'success'
                });
                drawListAndPagination();
              }else{
                this.$message({
                  message: this.translateText("textMap.", '设置失败'),
                  type: 'warning'
                });
              }
            }).catch(e => {
              this.$message({
                message: this.translateText("textMap.", '设置失败'),
                type: 'success'
              });
            })
          };

          const actionsTd = tr.querySelector('.actions');
          actionsTd.appendChild(deleteBtn);
          actionsTd.appendChild(defaultBtn);

          tbody.appendChild(tr);
        });

        table.appendChild(tbody);

        dataList.innerHTML = ''
        dataList.appendChild(table);

        renderPagination(dataList);
      };

      const renderPagination = (container) => {
        const pagination = document.createElement('div');
        pagination.className = 'pagination'
        pagination.style.marginTop = '10px';
        pagination.style.textAlign = 'right';

        const createButton = (text, disabled, handler) => {
          const btn = document.createElement('button');
          btn.innerText = text;
          btn.disabled = disabled;
          btn.style.margin = '0 3px';
          btn.onclick = handler;
          return btn;
        };

        const gotoPage = (page) => {
          if (page >= 0 && page < this.totalPages) {
            this.nowPage = page;
            drawListAndPagination();
          }
        };

        // 首页、上一页
        pagination.appendChild(createButton('«', this.nowPage === 0, () => gotoPage(0)));
        pagination.appendChild(createButton('‹', this.nowPage === 0, () => gotoPage(this.nowPage - 1)));

        // 显示中间最多5个页码按钮
        // 显示最多5个页码按钮（始终显示5个，除非总页数不足）
        const maxButtons = 5;

        if (this.totalPages <= maxButtons) {
          // 总页数不足5页时显示全部
          for (let i = 0; i < this.totalPages; i++) {
            const btn = createButton(i + 1, false, () => gotoPage(i));
            if (i === this.nowPage) btn.style.fontWeight = 'bold';
            pagination.appendChild(btn);
          }
        } else {
          let start, end;

          // 处理前3页的情况
          if (this.nowPage < 3) {
            start = 0;
            end = maxButtons; // 0-4（显示1-5页）
          }
          // 处理后3页的情况
          else if (this.nowPage > this.totalPages - 4) {
            start = this.totalPages - maxButtons;
            end = this.totalPages; // 最后5页
          }
          // 处理中间页
          else {
            start = this.nowPage - 2;  // 当前页前2页
            end = this.nowPage + 3;    // 当前页后2页（共5页）
          }

          // 创建页码按钮
          for (let i = start; i < end; i++) {
            const btn = createButton(i + 1, false, () => gotoPage(i));
            if (i === this.nowPage) btn.style.fontWeight = 'bold';
            pagination.appendChild(btn);
          }
        }

        // 下一页、尾页
        pagination.appendChild(createButton('›', this.nowPage === this.totalPages - 1, () => gotoPage(this.nowPage + 1)));
        pagination.appendChild(createButton('»', this.nowPage === this.totalPages - 1, () => gotoPage(this.totalPages - 1)));

        container.appendChild(pagination);
      };
      await drawListAndPagination();

      const buttons = document.createElement('div');
      buttons.className = 'buttons';
      buttons.innerHTML = `
        <button id="dataBaseListMenuCancel"">${this.translateText("textMap.", '取消')}</button>
        <button id="dataBaseListMenuSave">${this.translateText("textMap.", '保存')}</button>
      `;
      dataBaseListMenuBody.appendChild(buttons);

      dataBaseListMenu.appendChild(dataBaseListMenuBody);


      //分页功能结束
      const chartDom = document.getElementById('myTrendChart');
      chartDom.appendChild(dataBaseListMenu);

      this.mask = document.createElement('div');
      this.mask.className = 'createDataSetMask';
      this.mask.id = 'createDataSetMask';
      this.mask.addEventListener('click', () => {
        this.clear();
      });
      document.body.appendChild(this.mask);

      const createDataSetCancel = document.getElementById('dataBaseListMenuCancel');
      createDataSetCancel.addEventListener('click', () => {
        this.clear();
      });
      const createDataSetSave = document.getElementById('dataBaseListMenuSave');
      createDataSetSave.addEventListener('click', async () => {
        let nowData;
        try {
          let selectedRadio = document.querySelector('input[name="nowDataInDataBaseListMenu"]:checked').value;
          nowData = this.dataList[selectedRadio]
        }catch (e){
          this.$message({
            message: this.translateText("textMap.", '未选中基准数据'),
            type: 'warning'
          });
          return
        }
        let url = '';
        if(nowData.info.eventId){
          url = "/wave-spectrum/" + this.requistData.equipmentUuid + '/' + encodeURIComponent(encodeURIComponent(this.requistData.pointIdString.split(',')[this.nowSeriesIndex])) + '/' + nowData.markTime + '/16384/0/info?eventId=' + nowData.info.eventId + '&rev=' + nowData.info.rev
        }else{
          url = "/wave-spectrum/" + this.requistData.equipmentUuid + '/' + encodeURIComponent(encodeURIComponent(this.requistData.pointIdString.split(',')[this.nowSeriesIndex])) + '/' + nowData.markTime + '/16384/0/info'
        }
        let res1 = await this.$axios.get(url);
        this.nowData.timestamp = nowData.markTime;
        if (this.nowFeature == 'one' || this.nowFeature == 'phaseOne') {
          this.nowData.phaseNum = res1.data.data.trendValue[0].phaseOne;
          this.nowData.num = res1.data.data.trendValue[0].one;
        } else if (this.nowFeature == 'two' || this.nowFeature == 'phaseTwo') {
          this.nowData.phaseNum = res1.data.data.trendValue[0].phaseTwo;
          this.nowData.num = res1.data.data.trendValue[0].two;
        } else if (this.nowFeature == 'three' || this.nowFeature == 'phaseThree') {
          this.nowData.phaseNum = res1.data.data.trendValue[0].phaseThree;
          this.nowData.num = res1.data.data.trendValue[0].three;
        } else if (this.nowFeature == 'half' || this.nowFeature == 'phaseHalf') {
          this.nowData.phaseNum = res1.data.data.trendValue[0].phaseHalf;
          this.nowData.num = res1.data.data.trendValue[0].half;
        }
        console.log(nowData)
        this.offsets()
        console.log(this.requistData);
      })

    },

    //矢量差
    offsets() {
      this.clear()

      const option = this.mychart.getOption()
      console.log(this.nowSeriesIndex)
      let r2 = this.nowData.num; // 低速时慢滚动的向量长度
      let theta2 = this.nowData.phaseNum; // 低速时慢滚动的向量角度

      this.chartData.trendInfo.forEach((item, index) => {
        let initital = item.trendValue[this.nowSeriesIndex];
        // 定义两个向量的极坐标
        let r1;
        let theta1;
        if (this.nowFeature == 'one' || this.nowFeature == 'phaseOne') {
          r1 = initital.one;
          theta1 = initital.phaseOne;
        } else if (this.nowFeature == 'two' || this.nowFeature == 'phaseTwo') {
          r1 = initital.two;
          theta1 = initital.phaseTwo;
        } else if (this.nowFeature == 'three' || this.nowFeature == 'phaseThree') {
          r1 = initital.three;
          theta1 = initital.phaseThree;
        } else if (this.nowFeature == 'half' || this.nowFeature == 'phaseHalf') {
          theta1 = initital.phaseHalf;
          r1 = initital.half;
        }

        // 将极坐标转换为直角坐标
        const x1 = r1 * Math.cos(theta1 * Math.PI / 180);
        const y1 = r1 * Math.sin(theta1 * Math.PI / 180);
        const x2 = r2 * Math.cos(theta2 * Math.PI / 180);
        const y2 = r2 * Math.sin(theta2 * Math.PI / 180);

        // 计算矢量差的直角坐标
        const x_diff = x1 - x2;
        const y_diff = y1 - y2;

        // 将矢量差的直角坐标转换回极坐标
        const r_diff = Math.sqrt(x_diff * x_diff + y_diff * y_diff);
        let theta_diff = Math.atan2(y_diff, x_diff) * (180 / Math.PI);

        // 将负角度转换为正角度
        if (theta_diff < 0) {
          theta_diff += 360;
        }

        if (this.nowFeature.includes('phase')) {
          option.series[this.nowSeriesIndex].data[index][1] = theta_diff;
        } else {
          option.series[this.nowSeriesIndex].data[index][1] = r_diff;
        }
      })

      // 输出补偿值
      // console.log(`补偿值: ${r_diff.toFixed(2)} um pp @ ${theta_diff.toFixed(0)}°`);


      //添加markpoint
      // option.series[0].markPoint.data.push({
      //   name: "offsetMarkPoint",
      //   coord: [
      //     ...option.series[0].data[this.PrimaryLineParam.xIndex]
      //   ],
      //   symbol: "circle",
      //   symbolSize: 5,
      //   itemStyle: {
      //     color: "#9800f4"
      //   },
      //   label: {
      //     show: true,  // 这个点的 label 会一直显示
      //     formatter: this.translateText('all.','补偿值') + ': ' + option.series[0].data[this.PrimaryLineParam.xIndex][1].toFixed(2),
      //     color: "#9800f4",
      //     position: 'top'
      //   },
      // })

      //游标标点位置
      // 主游标点
      if (
        option.series &&
        option.series[0] &&
        option.series[0].markPoint &&
        option.series[0].markPoint.data
      ) {
        option.series[0].markPoint.data.forEach(item => {
          if (item.name === '主游标点') {
            const seriesData =
              option.series[this.PrimaryLineSeriesNameIndex] &&
              option.series[this.PrimaryLineSeriesNameIndex].data;
            if (seriesData && seriesData[this.PrimaryLineParam.xIndex]) {
              item.coord[1] = seriesData[this.PrimaryLineParam.xIndex][1];
            }
          }
        });
      }

      // 辅游标点
      if (
        option.series &&
        option.series[0] &&
        option.series[0].markPoint &&
        option.series[0].markPoint.data
      ) {
        option.series[0].markPoint.data.forEach(item => {
          if (item.name === '辅游标点') {
            const seriesData =
              option.series[this.SecondaryLineSeriesNameIndex] &&
              option.series[this.SecondaryLineSeriesNameIndex].data;
            if (seriesData && seriesData[this.SecondaryLineParam.xIndex]) {
              item.coord[1] = seriesData[this.SecondaryLineParam.xIndex][1];
            }
          }
        });
      }

      //游标标题
      option.title.forEach(item => {
        if (item.id == 'Auxiliary-Cursor' && item.text != '') {
          item.show = false
          let prefix = item.text.split(',')[0] + ', ';
          item.text = prefix + option.series[this.SecondaryLineSeriesNameIndex].data[this.SecondaryLineParam.xIndex][1].toFixed(2).toString() + ']';
        }
        if (item.id == 'offset' && item.text != '') {
          item.show = false
          let primary = option.series[this.PrimaryLineSeriesNameIndex].data[this.PrimaryLineParam.xIndex][1];
          let secondary = option.series[this.SecondaryLineSeriesNameIndex].data[this.SecondaryLineParam.xIndex][1];
          item.text = item.text.replace(/(\d+\.\d+)/, Math.abs(primary - secondary).toFixed(2));
        }
        if (item.id == 'Main-Cursor' && item.text != '') {
          item.show = false
          let prefix = item.text.split(',')[0] + ', ';
          item.text = prefix + option.series[this.PrimaryLineSeriesNameIndex].data[this.PrimaryLineParam.xIndex][1].toFixed(2).toString() + ']';
        }
        if (item.id == 'offsets') {
          item.show = true
          item.text = `${this.translateText("textMap.", "补偿时间：") + timestampToTimeFormat(this.nowData.timestamp)}`
        }
      })

      //y轴范围
      let mySeries = option.series;
      let amax = Number.NEGATIVE_INFINITY, amin = Number.POSITIVE_INFINITY;
      for (let _item in mySeries) {
        for (let item in mySeries[_item].data) {
          if (option.xAxis[0].type != 'category') {
            amax = Math.max(amax, mySeries[_item].data[item][1]);
            amin = Math.min(amin, mySeries[_item].data[item][1]);
          } else {
            amax = Math.max(amax, mySeries[_item].data[item]);
            amin = Math.min(amin, mySeries[_item].data[item]);
          }
        }
      }
      amax = this.roundUp(amin, amax)
      amin = this.roundDown(amin, amax)
      option.yAxis[0].max = amax;
      option.yAxis[0].min = amin;

      this.mychart.setOption(option);
    },

    //还原初始图谱
    restore() {
      this.clear();

      //图谱数据恢复初始
      const option = this.mychart.getOption();

      this.chartData.trendInfo.forEach((item, index) => {
        item.trendValue.forEach((seriesitem, seriesIndex) => {
          option.series[seriesIndex].data[index][1] = item.trendValue[seriesIndex][this.nowFeature];
        })
      })

      //清除markpoint
      // option.series[0].markPoint.data = option.series[0].markPoint.data.filter(item => {
      //   item.name != 'offsetMarkPoint';
      // })

      //标标点位置
      option.series[0].markPoint.data.forEach(item => {
        if (item.name == '主游标点') {
          item.coord[1] = option.series[this.PrimaryLineSeriesNameIndex].data[this.PrimaryLineParam.xIndex][1];
        }
      })
      option.series[0].markPoint.data.forEach(item => {
        if (item.name == '辅游标点') {
          item.coord[1] = option.series[this.SecondaryLineSeriesNameIndex].data[this.SecondaryLineParam.xIndex][1];
        }
      })

      //游标标题
      option.title.forEach(item => {
        item.show = true
        if (item.id == 'Main-Cursor' && item.text != '') {
          let prefix = item.text.split(',')[0] + ', ';
          item.text = prefix + option.series[this.PrimaryLineSeriesNameIndex].data[this.PrimaryLineParam.xIndex][1].toFixed(2) + ']';
        }
        if (item.id == 'offset' && item.text != '') {
          let primary = option.series[this.PrimaryLineSeriesNameIndex].data[this.PrimaryLineParam.xIndex][1];
          let secondary = option.series[this.SecondaryLineSeriesNameIndex].data[this.SecondaryLineParam.xIndex][1];
          item.text = item.text.replace(/(\d+\.\d+)/, Math.abs(primary - secondary).toFixed(2));
        }
        if (item.id == 'Auxiliary-Cursor' && item.text != '') {
          let prefix = item.text.split(',')[0] + ', ';
          item.text = prefix + option.series[this.SecondaryLineSeriesNameIndex].data[this.SecondaryLineParam.xIndex][1].toFixed(2) + ']';
        }
        if (item.id == 'offsets') {
          item.show = false
          item.text = `${this.translateText("textMap.", "补偿时间：") + timestampToTimeFormat(this.nowData.timestamp)}`
        }
      })


      //y轴范围
      let mySeries = option.series;
      let amax = Number.NEGATIVE_INFINITY, amin = Number.POSITIVE_INFINITY;
      for (let _item in mySeries) {
        for (let item in mySeries[_item].data) {
          if (option.xAxis[0].type != 'category') {
            amax = Math.max(amax, mySeries[_item].data[item][1]);
            amin = Math.min(amin, mySeries[_item].data[item][1]);
          } else {
            amax = Math.max(amax, mySeries[_item].data[item]);
            amin = Math.min(amin, mySeries[_item].data[item]);
          }
        }
      }
      amax = this.roundUp(amin, amax)
      amin = this.roundDown(amin, amax)
      option.yAxis[0].max = amax;
      option.yAxis[0].min = amin;


      this.mychart.setOption(option);
    },

    //清理所有补偿相关dom
    clear() {
      let tmp = document.getElementById(this.contextMenuId);
      if (tmp) {
        tmp.remove();
      }
      tmp = document.getElementById(this.selectListMenuId);
      if (tmp) {
        tmp.remove();
      }
      tmp = document.getElementById(this.createDataSetMenuId);
      if (tmp) {
        tmp.remove();
      }
      tmp = document.getElementById(this.dataBaseListMenuId);
      if (tmp) {
        tmp.remove();
      }
      if (this.mask) {
        this.mask.remove();
      }
    }
  },
}

export default offsetsMixin



// WEBPACK FOOTER //
// ./src/mixins/offsetsMixin.js